import React, { useState } from "react";
import "./Page2_EnterDetails.css";
import { Form, Row, Col } from "react-bootstrap";
import Common_Title from "../../common_components/common_title/Common_Title";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faCalendarDays,
  faHourglassHalf,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import SuccessToast from "../successModal/SuccessModal";
import SuccessModal from "../successModal/SuccessModal";
import { useForm } from "react-hook-form";
import axios from "axios";

function Page2_EnterDetails({ selectedDate, timeSlot }) {
  const [step, setStep] = useState(1); // <<< MAIN STEP CONTROL
  const [showModal, setShowModal] = useState(false);

  const handleSchedule = () => {
    setShowModal(true);

    // hide automatically after 3 sec
    // setTimeout(() => {
    //   setShowModal(false);
    // }, 3000);
  };

  const formatFullDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    console.log("Submitted Data step1 :", data);
    setStep(2);
  };

  const onSubmitLast = async (data) => {
    try {
      const payload = {
        ...data,
        time_slot: timeSlot,
        date: selectedDate,
      };

      // const response = await axios.post(
      //   `${process.env.REACT_APP_BASE_URL}/profcyma-b2b/form/appointment`,
      //   payload
      // );

      handleSchedule();
    } catch (err) {
      console.error("Submit Error:", err);
    }
  };
  const [showGuestInput, setShowGuestInput] = useState(false);

  return (
    <>
      <section className="Page1_Scheduler Page2_EnterDetails">
        <Row className="justify-content-center">
          <div className="  col-lg-7 col-md-12  col-12  order-lg-1  order-md-2 order-2">
            <div className="p1_left">
              <div className="title_holder">
                <Common_Title
                  simpleText="Individualized, "
                  darkText="High-Impact Strategy Call"
                />
              </div>

              <div className="heading_list_holder">
                <ul>
                  <li>
                    {" "}
                    <FontAwesomeIcon
                      icon={faHourglassHalf}
                      className="me-3"
                    />{" "}
                    30 Mins
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon icon={faVideo} className="me-3" /> Web
                    conferencing details provided upon confirmation.
                  </li>
                  <li>
                    {" "}
                    <FontAwesomeIcon icon={faCalendarDays} className="me-3" />
                    {timeSlot}, {formatFullDate(selectedDate)}
                  </li>
                </ul>
              </div>

              <div className="form_step_holder">
                <div className="form_heading_holder">
                  <h5>Enter Details</h5>
                  <h3>{step}/2</h3>
                </div>

                {step === 1 && (
                  <div className="form_holder">
                    <Row className="mt-4">
                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Mobile Number</Form.Label>
                          <Form.Control
                            maxLength={10}
                            placeholder="Enter Mobile Number"
                            {...register("contact_no", {
                              required: "Mobile number is required",
                              pattern: {
                                value: /^[0-9]{10}$/,
                                message: "Enter valid 10-digit mobile number",
                              },
                            })}
                            onKeyPress={(e) => {
                              if (!/[0-9]/.test(e.key)) {
                                e.preventDefault(); // blocks non-numeric input
                              }
                            }}
                          />
                          {errors.contact_no && (
                            <p className="error_text">
                              {errors.contact_no.message}
                            </p>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Enter Name</Form.Label>
                          <Form.Control
                            placeholder="Enter Name"
                            {...register("full_name", {
                              required: "Full name is required",
                            })}
                          />
                          {errors.full_name && (
                            <p className="error_text">
                              {errors.full_name.message}
                            </p>
                          )}

                          <div
                            className="note_holder"
                            onClick={() => setShowGuestInput(!showGuestInput)}
                          >
                            <p>
                              {showGuestInput ? "Remove Guest" : "Add Guest"}
                            </p>
                          </div>
                          {showGuestInput && (
                            <div className="field_holder">
                              <Form.Label>Guest Name</Form.Label>

                              <Form.Control
                                placeholder="Enter Guest Name"
                                {...register("guest", {
                                  required: "Guest name is required",
                                })}
                              />

                              {errors.guest && (
                                <p className="error_text">
                                  {errors.guest.message}
                                </p>
                              )}
                            </div>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Email</Form.Label>
                          <Form.Control
                            placeholder="Enter Email Id"
                            {...register("email", {
                              required: "Email is required",
                              pattern: {
                                value: /^([A-Za-z0-9_\-\.])+\@(?!(?:[A-Za-z0-9_\-\.]+\.)?([A-Za-z0-9_\-\.]+)\.\2)([A-Za-z0-9_\-\.]+\.)+([A-Za-z]{2,4})$/,
                                message: "Enter a valid email",
                              },
                            })}
                          />
                          {errors.email && (
                            <p className="error_text">{errors.email.message}</p>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {step === 2 && (
                  <div className="form_holder">
                    <Row className="mt-4">
                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Name of Your Institute</Form.Label>
                          <Form.Control
                            placeholder="Enter Institute Name"
                            {...register("institute", {
                              required: "Institute name is required",
                            })}
                          />
                          {errors.institute && (
                            <p className="error_text">
                              {errors.institute.message}
                            </p>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Monthly Making Budget</Form.Label>

                          <div className="checkbox_list">
                            {[
                              "Below ₹ 50,000/-",
                              "₹ 50,000/- to ₹ 1,00,000/-",
                              "₹ 1,00,000/- to ₹ 3,00,000/-",
                              "₹ 3,00,000/- to ₹ 5,00,000/-",
                              "More than ₹ 5,00,000/-",
                            ].map((label, index) => (
                              <Form.Check
                                key={index}
                                type="radio"
                                label={label}
                                value={label}
                                {...register("budget", {
                                  required: "Budget is required",
                                })}
                              />
                            ))}
                          </div>

                          {errors.budget && (
                            <p className="error_text">
                              {errors.budget.message}
                            </p>
                          )}
                        </div>
                      </Col>

                      <Col md={12}>
                        <div className="field_holder">
                          <Form.Label>Send Message to</Form.Label>
                          <Form.Control
                            placeholder="Enter Mobile Number"
                            {...register("message", {
                              required: "Message is required",
                            })}
                          />
                          {errors.message && (
                            <p className="error_text">
                              {errors.message.message}
                            </p>
                          )}
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}
              </div>

              {/* BUTTONS */}
              <div className="step_btns">
                {/* NEXT BUTTON */}
                {step === 2 && (
                  <button className="back_btn" onClick={() => setStep(1)}>
                    Back
                  </button>
                )}

                {/* NEXT BUTTON */}
                {step === 1 && (
                  <button
                    className="next_btn"
                    // onClick={() => setStep(2)}
                    onClick={handleSubmit(onSubmit)}
                  >
                    Next
                  </button>
                )}

                {/* SUBMIT BUTTON ON STEP 2 */}
                {step === 2 && (
                  <button
                    className="next_btn"
                    // onClick={handleSchedule}
                    onClick={handleSubmit(onSubmitLast)}
                  >
                    Schedule
                  </button>
                )}
              </div>
            </div>
          </div>

          <div className="  col-lg-5 col-md-6 col-sm-6  order-lg-2  order-md-1 order-1 ">
            <div className="p1_right text-center">
              <div className="img_holder">
                <img
                  src="/assets/images/appoinment/right_img_1.png"
                  alt="calendar"
                  className="banner_img"
                />
              </div>
            </div>
          </div>
        </Row>
      </section>
      {/* Toast Message */}
      <SuccessModal show={showModal} onHide={() => setShowModal(false)} />
    </>
  );
}

export default Page2_EnterDetails;
